module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_11_3.77d4306a.jpeg";